module.exports = __webpack_public_path__ + "static/JP-6165680830902a096128591f359c2419.png";